<template>
  <div class="block">
    <el-date-picker
      class="date-picker"
      v-model="value"
      value-format="yyyy-MM-dd HH:mm:ss"
      format="yyyy-MM-dd HH:mm:ss"
      @change="dataSearch"
      type="datetimerange"
      range-separator="-"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
	:default-time="['00:00:00', '23:59:59']"
      align="right">
    </el-date-picker>
    <el-button type="primary" size="mini" style="margin-left: 10px; height:32px" @click="search" >查询</el-button>
    <span class="date-type">
      <el-radio-group v-model="radio" size="small" @change="changeDate">
        <el-radio-button v-for="date in datesList" :label="date" :key="date">{{date}}</el-radio-button>
      </el-radio-group>
    </span>
  </div>
</template>

<script>
export default {
  data() {
    return {
      value: [],
      radio: '全部',
      datesList: ['今日','本月', '全部'],
      dataTime: ''
    };
  },
  filters: {
    timestampToTime(timestamp) {
      var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = (date.getDate()<10?'0'+(date.getDate()):date.getDate());
      var h = (date.getHours()<10?'0'+(date.getHours()):date.getHours())+ ':';
      var m = (date.getMinutes()<10?'0'+(date.getMinutes()):date.getMinutes()) + ':';
      var s = (date.getSeconds()<10?'0'+(date.getSeconds()):date.getSeconds());
      return Y + M + D +' '+ h + m + s;
    }
  },
  mounted() {
    let dataTime = []
    this.$emit('dataSearch', dataTime )
  },
  methods: {
    //快速定位日期
    changeDate(){
      var transTe = this.$options.filters['timestampToTime'];
      const end = new Date()
      const start = new Date();
      var newStart = '';
      var newEnd = '';
      newEnd = transTe(end)
      if(this.radio== '今日') {
        newStart = transTe(start).split(" ")[0] + ' 00:00:00'
        console.log("newStart",newStart)
      }else if(this.radio== '本月') {
        let every = transTe(start).split(" ")[0].split("-")
        newStart = every[0] + '-' + every[1] + '-01 00:00:00'
        console.log("newStart22",newStart)
      }
      if(this.radio == '全部'){
        let dataTime = []
        this.$emit('dataSearch', dataTime )
      }else {
        let dataTime = []
        dataTime.push(newStart,newEnd)
        this.$emit('dataSearch', dataTime )
      }
    },
    //获取选中日期的值
    dataSearch(value) {
      console.log("dataSearch",value)
      let newValue = []
      value.forEach(item => {
        newValue.push(`${item} 00:00:00`)
      })
      console.log("newValue",newValue)
      this.value = newValue
    },
    search() {
      this.$emit('dataSearch', this.value)
    }
  }
};
</script>
<style scoped lang="stylus">
.block
  display: flex
  justify-content: flex-end
  align-items: center
  height: 32px
.block/deep/.el-input__icon
  display: flex
  align-items: center
.date-type
  padding-left: 20px
  display: flex
  align-items: center
.date-picker
  width: 250px
  height: 32px
/deep/.el-range-editor--medium .el-range-separator
  line-height: 25px
</style>